<template>
  <article>
    <flexbox class="offer-title" justify="space-between" align="flex-end">
      <flexbox-item>
        <div class="left-title">{{info.auction.status_name}}</div>
      </flexbox-item>
      <flexbox-item>
        <div class="right-title">{{info.match_status_code | showStatus}}</div>
      </flexbox-item>
    </flexbox>
    <group gutter="0" class="offer-record fn-red">
      <cell :title="info.auction.session">
        <div slot="icon">竞拍时间</div>
      </cell>
      <cell :title="info.auction.bidders_count+'人/'+info.auction.bids_count + ' 次'">
        <div slot="icon">出价人次</div>
      </cell>
      <cell :title="info.auction.minimum_price | formatePrice">
        <div slot="icon">起拍价</div>
      </cell>
      <cell :title="info.auction.reserve_price | formatePrice">
        <div slot="icon">保留价</div>
      </cell>
      <cell>
        <div slot="icon">最高价</div>
        <div slot="after-title"><span class="fc-red">{{(info.auction.maximum_price / 1000000).toFixed(2) }}</span>万元</div>
      </cell>
      <cell :title="info.auction.quote_increment | formatePrice02">
        <div slot="icon">加价幅度</div>
      </cell>
    </group>
    <group title="出价记录" class="bid-record-wrap">
      <template v-if="info.auction.status_name === '竞拍中'">
         <cell v-for="(item, index) in info.bids" :key="index" :title="item.price | formatePrice" class="price-record">
          <div slot="value">{{item.bidden_at}}</div>
        </cell>
      </template>
      <template v-else>
         <cell v-for="(item, index) in info.bids" :key="index" :inline-desc="item.bidder.name + ' '+ item.bidder.mobile_number+ ' '+item.bidder.city" :title="item.price | formatePrice" class="price-record" @click.native="toDetail(item.bidder.id)">
          <div slot="value">{{item.bidden_at}}</div>
          <span slot="icon" :class="{'icon':item.selected}"></span>
        </cell>
      </template>
    </group>
    <!-- 底部撮合时间倒计时及按钮 -->
    <div class="btn-bottom">
      <flexbox v-if="info.matchable" class="match-time-wrap" justify="space-between">
        <flexbox-item :span="8">
          剩余撮合时间
          <span>
            <clocker :time="info.match_submit_before" slot="value">
              <span class="time-bg">%D</span>天
              <span class="time-bg">%H</span>:
              <span class="time-bg">%M</span>:
              <span class="time-bg">%S</span>
            </clocker>
          </span>
        </flexbox-item>
        <flexbox-item>
          <x-button type="primary" class="match-btn" @click="submitMatch">撮合</x-button>
        </flexbox-item>
      </flexbox>
    </div>
  </article>
</template>
<script>
// 出价信息
import { Cell, XButton, Group, Flexbox, FlexboxItem, Clocker } from '@lx-frontend/cvux'
export default {
  components: {
    Cell,
    XButton,
    Flexbox,
    FlexboxItem,
    Clocker,
    Group
  },
  data() {
    return {
      info: {
        'auction': {
          'session': '',
          'status_name': '',
          'bidders_count': 0,
          'bids_count': 0,
          'minimum_price': 0,
          'reserve_price': 0,
          'maximum_price': 0,
          'quote_increment': 0
        },
        matchable: false,
        'bids': []
      }
    }
  },
  created() {
    let auctionId = this.$route.params.id
    if (auctionId) {
      this.$rest.auction.getOfferInfo(null, auctionId + '/bids').then((res) => {
        if (res.code === 0) {
          this.info = res.data
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  methods: {
    toDetail(id) {
      if (id) {
        this.$router.push({ path: '/auction/detail/' + id })
      }
    },
    submitMatch() {
      this.$router.push({ path: `/auction/match/submit/${this.info.auction.id}` })
    }
  },
  filters: {
    formatePrice(price) {
      return `${(price / 1000000).toFixed(2)}万元`
    },
    formatePrice02(price) {
      return `${(price / 100).toFixed(0)}元`
    },
    showStatus(statusCode) {
      let result = ''
      switch (statusCode) {
        case 'created':
          result = '待车商确认'
          break
        case 'pending_payment':
          result = '待收款'
          break
        case 'completed':
          result = '已成交'
          break
        case 'closed':
          result = '已关闭'
          break
        case 'rejected':
          result = '已拒绝'
          break
        default:
          result = ''
      }
      return result
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/auction/offer.less";

</style>
